import React, { useEffect, useState } from "react";
import { Modal, Button, Alert, Form, Label, Input } from "@/Components/Common/Tailwind";

interface Coupon {
  discount_type: string;
  discount_amount: number;
  discount_rate: number;
  expire_date: string | null;
  bound_type: string;
  use_start_date: string;
  use_end_date: string;
  min_purchase: number;
  image?: string;
}

interface CouponInfo {
  id: number;
  coupon_name: string;
  state: string;
  coupon: Coupon;
  share_pin_code?: string;
  share_count?: number;
  share_state?: string;
}

interface CouponInfoModalProps {
  info: CouponInfo;
  setInfo: (info: CouponInfo | {}) => void;
  visible: boolean;
  setVisible: (visible: boolean) => void;
  needRefresh?: () => void;
}

const CouponInfoModal = ({ info, setInfo, visible, setVisible, needRefresh }: CouponInfoModalProps) => {
  const togModal = () => {
    setVisible(!visible);
  };

  return (
    <React.Fragment>
      {Object.keys(info).length !== 0 ? (
        <Modal toggle={togModal} isOpen={visible} centered>
          <div>
            <div className="mb-4 flex justify-center"></div>
            <ul className="list-group">
              <li className="list-group-item">쿠폰이름: {info?.coupon_name}</li>
              <li className="list-group-item">
                할인금액 : {info?.coupon.discount_type === "price" ? `${info.coupon.discount_amount.toLocaleString()}원 할인쿠폰` : `${info.coupon.discount_rate}% 할인쿠폰`}
              </li>
              <li className="list-group-item">만료기한 : {info.coupon.expire_date}</li>
              {info.coupon.bound_type === "reservation" ? (
                <li className="list-group-item">
                  예약가능기간: {info.coupon.use_start_date} ~ {info.coupon.use_end_date}
                </li>
              ) : null}

              <li className="list-group-item">사용정보 : {info.coupon.min_purchase.toLocaleString()}원 이상 구매시 사용가능</li>
              <li className="list-group-item">이용정보 : {info.state}</li>
            </ul>

            <div style={{ marginTop: "24px" }}></div>
          </div>
          <div className="flex justify-center mt-4">
            <Button
              variant="primary"
              onClick={() => {
                setInfo({});
                setVisible(false);
              }}
            >
              닫기
            </Button>
          </div>
        </Modal>
      ) : null}
    </React.Fragment>
  );
};
export default CouponInfoModal;
